import React, { Component } from 'react';
import Grid from 'screens/components/basic/Grid';
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import { reportMemberDemograpic } from 'utils/breadcrumbInfo';
import { getDemographicReport } from 'actions/ReportsAction';
import CardSimple from 'screens/components/basic/CardSimple';
import PageHeader from 'screens/components/basic/PageHeader';
import Body from './Body';
import Header from './Header';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

const gender = ["Male", "Female", "Gender non Conforming", "Non binary"];
const age = ["Younger than 29", "Between 30 - 54", "Between 55 - 74", "Over 75"];
const color = ["#549BE6", "#EB736E", "#FDBE48", "#82ca9d"]
class membersDemographics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showBody: false,
            genderReport: [],
            ageReport: [],
            totalMembers: [],
            mapGenderReport: [],
            mapAgeReport: []
        }
        this.showBody = this.showBody.bind(this),
        this.getDemographicReport = this.getDemographicReport.bind(this)
    }

    componentWillReceiveProps(newProps) {
        if (newProps.demographicReportTimeStamp && newProps.demographicReportTimeStamp !== this.props.demographicReportTimeStamp) {
            const notSelected = newProps.genderReport.find(x => x.type === 0);
            const notConfirming = newProps.genderReport.find(x => x.type === 3);

            let amount = 0;
            let percentage = 0;

            if (notSelected && notConfirming){
                amount = notSelected.amount + notConfirming.amount;
                percentage = notSelected.percentage + notConfirming.percentage;
            }

            const newPropsGenderReport = newProps.genderReport.map(item => {
                if (item.type === 3){
                    const newItem = {
                        ...item,
                        amount,
                        percentage
                    }
                    return newItem;
                }else{
                    return item;
                }
            })
            
            const mapGenderReport = newPropsGenderReport
                .filter(x => x.type !== 0 && x.type !== 3).map(item => {
                return {
                    name: typeof item.type === "number" ? gender[item.type - 1] : item.type,
                    value: item.percentage,
                    fill: color[item.type - 1]
                }
            })

            const mapAgeReport = newProps.ageReport.map(item => {
                return {
                    name: age[item.type - 1],
                    value: item.percentage,
                    fill: color[item.type - 1]
                }
            }).filter(x => x.name);

            this.setState({ ...this.state, genderReport: newPropsGenderReport, ageReport: newProps.ageReport, totalMembers: newProps.totalMembers, mapGenderReport, mapAgeReport }, this.showBody);
        }
    }

    showBody = (e) => {
        this.setState({ ...this.state, showBody: true });
    }

    getDemographicReport = () => {
        this.props.getDemographicReport(this.props.branchSelected || 0);
    }

    render() {
        return (
            <Grid headerContent={reportMemberDemograpic}>
                <PageHeader title={LOOKUP.report.membersDemographics.text}
                    description={LOOKUP.report.membersDemographics.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    showBody={this.getDemographicReport}
                    loggedBranch={this.props.branchId}
                />
                {this.state.showBody &&<DateCurrentDisplay />}
                <CardSimple>
                    <Body showBody={this.state.showBody} genderReport={this.state.genderReport} mapGenderReport={this.state.mapGenderReport} ageReport={this.props.ageReport} mapAgeReport={this.state.mapAgeReport} totalMembers={this.props.totalMembers} />
                </CardSimple>
            </Grid>
        )
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    brachOptions.push({ text: "All", value: "0" });
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        branchId: state.common.branchId,
        branchSelected: state.form.MemberDemographicBranchOption || [],
        genderReport: state.reports.demographicReportGender || [],
        ageReport: state.reports.demographicReportAge || [],
        totalMembers: state.reports.totalMembers || 0,
        demographicReportTimeStamp: state.reports.demographicReportTimeStamp
    };
};

const mapDispatchToProps = dispatch => {

    return {
        getDemographicReport: (branch) => dispatch(getDemographicReport(branch)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(membersDemographics);